import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { palette } from "lib/miolo";

interface IHeadquartersCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

export default function HeadquartersCard({ issuer }: IHeadquartersCardProps) {
  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 20 20">
      <g transform="translate(-28 -35)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="currentColor" strokeWidth={2}>
          <path d="M31.438 54.063h13.125a2.5 2.5 0 002.5-2.5v-9.375L38 35.938l-9.062 6.25v9.375a2.5 2.5 0 002.5 2.5z" />
          <path d="M35.187 49.687a2.5 2.5 0 012.5-2.5h.625a2.5 2.5 0 012.5 2.5v4.375h-5.625v-4.375z" />
        </g>
      </g>
    </svg>
  );

  if (issuer.headquarters.country === "Brasil") {
    let stateName = issuer.headquarters.state;
    const stateKey = issuer.headquarters.state as keyof typeof STATE_NAMES;
    if (stateName.length === 2 && STATE_NAMES[stateKey]) {
      stateName = STATE_NAMES[stateKey];
    }
    return (
      <div>
        <IconCard primaryColor={palette.scienceBlue} secondaryColor={palette.lilyWhite} icon={icon}>
          <CardValue title={issuer.headquarters.city}>{issuer.headquarters.city}</CardValue>
          <CardDescription>Sede • {stateName}</CardDescription>
        </IconCard>
      </div>
    );
  }

  return (
    <div>
      <IconCard primaryColor={palette.scienceBlue} secondaryColor={palette.lilyWhite} icon={icon}>
        <CardValue title={issuer.headquarters.country}>{issuer.headquarters.country}</CardValue>
        <CardDescription>Sede</CardDescription>
      </IconCard>
    </div>
  );
}

const STATE_NAMES = {
  AC: "Acre",
  AL: "Alagoas",
  AM: "Amazonas",
  AP: "Amapá",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MG: "Minas Gerais",
  MS: "Mato Grosso do Sul",
  MT: "Mato Grosso",
  PA: "Pará",
  PB: "Paraíba",
  PE: "Pernambuco",
  PI: "Piauí",
  PR: "Paraná",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RO: "Rondônia",
  RR: "Roraima",
  RS: "Rio Grande do Sul",
  SC: "Santa Catarina",
  SE: "Sergipe",
  SP: "São Paulo",
  TO: "Tocantins",
};
